var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProfileOptionSelector',{attrs:{"model":'schoolType',"nextRoute":_vm.nextRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }